import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PbxSettingsComponent } from "./pbx-settings.component";
import { PbxSettingsRoutingModule } from "@onsip/web/features/administrators/pbx-settings/pbx-settings-routing.module";
import { LayoutModule } from "@onsip/web/features/shared/components/layout/layout.module";
import { TranslateModule } from "@ngx-translate/core";
import { MatCardModule } from "@angular/material/card";
import { ShellNavigationsModule } from "@onsip/web/features/shared/components/shellNavigations/shell-navigations.module";
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [PbxSettingsComponent],
  imports: [
    CommonModule,
    PbxSettingsRoutingModule,
    LayoutModule,
    TranslateModule,
    MatCardModule,
    ShellNavigationsModule,
    RouterModule
  ]
})
export class PbxSettingsModule {}
